import { prefix } from 'helpers/component'

const act = prefix('sign-up/final/')

const FINALISE_ATTEMPT = act('FINALISE_ATTEMPT')
const FINALISE_SUCCESS = act('FINALISE_SUCCESS')
const FINALISE_FAILURE = act('FINALISE_FAILURE')

export const types = {
  FINALISE_ATTEMPT,
  FINALISE_SUCCESS,
  FINALISE_FAILURE,
}

export const finalise = (data) => ({ type: FINALISE_ATTEMPT, data })
export const finaliseSuccess = (data) => ({ type: FINALISE_SUCCESS, data })
export const finaliseFailure = (error) => ({ type: FINALISE_FAILURE, error })
